export class FacebookPixel {
    constructor() { }
    static init(f, b, e, v, n, t, s) {
        if (f.fbq)
            return;
        n = f.fbq = function () {
            if (n.callMethod) {
                n.callMethod.apply(n, arguments);
            }
            else {
                n.queue.push(arguments);
            }
        };
        if (!f._fbq)
            f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }
    static load(callback = () => { }) {
        this.init(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', '433093840613871');
        window.fbq('track', 'PageView');
        callback();
    }
    static send({ eventType, event, data }) {
        if ('fbq' in window) {
            window.fbq(eventType, event, data);
        }
        else {
            console.error('Hey! Facebook pixel not found');
        }
    }
}
